
/* Generated apis ---------------------- */
import { to } from 'react-lib/utils'
import BaseService from  'react-lib/apis/services/BaseService'
import config from '../../config/config'
import DoctorReviewsScoreSerializer from '../types/DoctorReviewsScoreSerializer_apps_PRX'


const HOST = `${config.API_HOST}`
/* ['SetLanguageContextMixin', 'generics.RetrieveAPIView'] */
/* params:  */
/* data:  */
const DoctorReviews : 
{
  retrieve: ({doctor_id, params, apiToken, extra}:
             { doctor_id: any, 
                params?: any,
                apiToken?: any,
                extra?: any,
            }) => any,
} = 
{
  retrieve: async ({doctor_id, params, apiToken, extra}) => {
    const base = new BaseService()
    if (apiToken)
      base.client.defaults.headers.common["Authorization"] = "Token " + apiToken;
    if (extra?.division)
      base.client.defaults.headers.common["division"] = extra.division;
    if (extra?.device)
      base.client.defaults.headers.common["device"] = extra.device;
    const result = await to(base.client.get(`${HOST}/apis/PRX/doctor_reviews/${doctor_id}/`,
      { params: params ? { ...params } : {},
         ...extra
      }
    )
    .then(base.handleResponse)
    .catch(base.throwErrorMessage))
    return [result[1], result[0], result[2]]
  },
}

export default DoctorReviews

